import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, CartProvider } from "./context/store";
import { Layout, Protected } from "./components/Layout";
import { ScrollTop } from "./components/ScrollTop";
import Home, { Products, ProductDetail } from "./pages/Shop";
import { Cart, Checkout, Pay, Confirmation, Orders, OrderDetail } from "./pages/Orders";
import { Login, Signup, ForgotPassword, ResetPassword, Profile, Wishlist } from "./pages/Account";
import { About, Quality, Sustainability, Gallery, Contact } from "./pages/Static";
import { AdminLayout, Dashboard, AdminOrders, AdminProducts, AdminCoupons, AdminMessages } from "./pages/Admin";

export default function App() {
  return (
    <AuthProvider><CartProvider><BrowserRouter><ScrollTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/about" element={<About />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected />}>
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pay/:orderNumber" element={<Pay />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/orders/:orderNumber" element={<OrderDetail />} />
            <Route path="/orders/:orderNumber/confirmation" element={<Confirmation />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/wishlist" element={<Wishlist />} />
          </Route>
          <Route element={<Protected admin />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="coupons" element={<AdminCoupons />} />
              <Route path="messages" element={<AdminMessages />} />
            </Route>
          </Route>
          <Route path="*" element={<div className="container-x py-24 text-center"><h2 className="text-3xl font-bold">Page not found</h2></div>} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter></CartProvider></AuthProvider>
  );
}
